import React from 'react';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const features = [
    {
      icon: "💳",
      title: "Low Service Charges",
      desc: "Industry-leading rates starting at just 1.79% for all major credit cards"
    },
    {
      icon: "⚡",
      title: "Instant Transfer",
      desc: "Get cash directly in your account within 5 minutes of swiping"
    },
    {
      icon: "🛡️",
      title: "Secure Process",
      desc: "Bank-grade security with encrypted transactions for your peace of mind"
    },
    {
      icon: "👛",
      title: "Bill Payment Service",
      desc: "We pay your credit card bills on time with minimal service charges"
    },
    {
      icon: "🕒",
      title: "24/7 Availability",
      desc: "Available round the clock to serve your urgent cash needs"
    },
    {
      icon: "✅",
      title: "All Cards Accepted",
      desc: "Visa, Mastercard, RuPay, and all HDFC cards accepted"
    }
  ];

  return (
    <section className="why-choose-section">
      <div className="section-header">
        <h2 className="section-title">Why Choose <span className="highlight">QuickCash?</span></h2>
        <p className="section-subtitle">
          Experience the fastest and most reliable credit card swiping service in Chennai
        </p>
      </div>

      <div className="features-container">
        {features.map((item, index) => (
          <div className="feature-item" key={index}>
            <div className="feature-icon-box">{item.icon}</div>
            <h3 className="feature-item-title">{item.title}</h3>
            <p className="feature-item-desc">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;